/**
 * Icons module - loads and registers the SVG sprite
 */

/**
 * Injects the SVG sprite into the DOM
 * This should be called once when the app initializes
 */
export function registerIcons () {
  // Fetch the sprite SVG file
  fetch('/img/sprite.svg')
    .then(response => {
      if (!response.ok) {
        throw new Error(`Failed to load sprite: ${response.status} ${response.statusText}`);
      }
      return response.text();
    })
    .then(spriteContent => {
      // Create a div to hold the sprite
      const spriteContainer = document.createElement('div');
      spriteContainer.style.display = 'none';
      spriteContainer.id = 'svg-sprite';

      // Directly insert the SVG sprite content
      spriteContainer.innerHTML = spriteContent;

      // Append to the body
      document.body.appendChild(spriteContainer);
    })
    .catch(error => {
      console.error('Error loading SVG sprite:', error);
    });
}

/**
 * Returns the list of all available icon names
 * @returns {string[]} Array of icon names
 */
export function getAvailableIcons () {
  // This will be populated by the sprite generation script
  return [
    'article-two', 'article-wan', 'blog', 'certification-icon', 'chevron-down',
    'contact', 'github-filled', 'github', 'happy-client', 'headset', 'help',
    'home', 'linkedin', 'logofolio', 'picture', 'speech-bubble', 'twitter', 'share',
    'facebook', 'reddit', 'whatsapp'
  ];
}
